import { render, staticRenderFns } from "./InsurancePolicy.vue?vue&type=template&id=732daaae&scoped=true"
import script from "./InsurancePolicy.vue?vue&type=script&lang=js"
export * from "./InsurancePolicy.vue?vue&type=script&lang=js"
import style0 from "./InsurancePolicy.vue?vue&type=style&index=0&id=732daaae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732daaae",
  null
  
)

export default component.exports